import Verified from "./Verified";

export default Verified;
